import { pipe, map, reduce } from '~js/utils'
import gaEvents from '~js/ga-events'
import { formatPanoramas, formatMarker } from '@/utils/format'
import PanoramasManager from '../../manager/panoramas-manager'

const state = {
  panoramas: [],
  currentPanorama: {},
  lastPanorama: {},
  hoveredPanorama: {}
}

export const getters = {
  panoramas: state => state.panoramas,
  currentPanorama: state => state.currentPanorama,
  lastPanorama: state => state.lastPanorama,
  hoveredPanorama: state => state.hoveredPanorama
}

export const actions = {
  async setPanoramas ({ commit, state, rootState, getters, dispatch }, panoramas) {
    const panoramasManager = new PanoramasManager({ dispatch, commit, state, rootState })
    if (panoramas.length <= 0) {
      panoramasManager.noPanoramasHandler()
    }
    panoramas = formatPanoramas(panoramas)

    const markers = pipe(
      map(panorama => panorama.markers || []),
      reduce((markerResult, markerArr) => markerResult.concat(markerArr))([]),
      map(formatMarker)
    )(panoramas)
    dispatch('setKrpanoActive', false)
    dispatch('setPanoramasNotFound', false)
    await dispatch('setBuildingMarkers', markers)
    dispatch('setProgressMax', panoramas.length + 12)
    panoramasManager.panoramaMarkersReadyHandler(panoramas) // will commit set panoramas panorama
  },

  selectPanorama ({ commit, state, rootState }, panorama) {
    if (!isNaN(Number(panorama))) {
      panorama = state.panoramas[panorama - 1]
    }
    if (typeof panorama === 'string') {
      panorama = state.panoramas.find(pano => pano.objectId === panorama)
    }

    if (state.currentPanorama.objectId === panorama.objectId ||
      rootState.progress.isProgressActive) {
      return
    }
    window.krpanoObj.call(`prepare_change_scene(panorama_${panorama.objectId || ''}, ${panorama.objectId || ''}, 'PanoramaList');`)
  },

  async setPanorama ({ commit, dispatch }, panorama = {}) {
    gaEvents.sendEvent('Panorama', 'ChangePano', panorama.objectId)
    const markers = panorama.markers
    dispatch('setMarkers', markers)
    dispatch('updateShareUrl')
    commit('SET_PANORAMA', panorama)
  },

  // comment out for no one use
  // updatePanoramaItem ({ commit, state }, panorama = {}) {
  //   let targetId = ''
  //   if (panorama.objectId) {
  //     targetId = panorama.objectId
  //   } else {
  //     targetId = state.currentPanorama.objectId
  //     commit('UPDATE_PANORAMA_ITEM', panorama)
  //   }

  //   const foundIndex = state.panoramas.map(panorama => panorama.objectId).indexOf(targetId)
  //   if (foundIndex <= -1) {
  //     return
  //   }
  //   const newPanorama = completeAssign({}, state.panoramas[foundIndex], panorama)
  //   const newPanoramas = state.panoramas.slice()
  //   newPanoramas.splice(foundIndex, 1, newPanorama)
  //   commit('SET_PANORAMAS', newPanoramas)
  // },

  setHoveredPanorama ({ commit }, panorama = {}) {
    commit('SET_HOVERED_PANORAMA', panorama)
  }
}

export const mutations = {
  SET_PANORAMAS (state, panoramas = []) {
    state.panoramas = panoramas
  },

  SET_PANORAMA (state, panorama = {}) {
    state.lastPanorama = state.currentPanorama
    state.currentPanorama = panorama
  },

  SET_HOVERED_PANORAMA (state, panorama = {}) {
    state.hoveredPanorama = panorama
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
